import Slider_desktop from './Slider_desktop';
import Slider_mobile from './Slider_mobile';
export default function SliderLayout(props) {
  return props.isPhone ? <Slider_mobile {...props} /> : <Slider_desktop {...props} />;
}
